import { render, staticRenderFns } from "./scenario-modelling.vue?vue&type=template&id=731f1636&"
import script from "./scenario-modelling.vue?vue&type=script&lang=js&"
export * from "./scenario-modelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports